
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavItem from '@/components/navigation/NavItem.vue';
import { mapActions, mapGetters } from 'vuex';
import Selector from '@/components/language/Selector.vue';
import { User } from '@/model/Profile';
import DashboardIcon from '@/assets/navbar/dashboard.svg?inline';
import CustomerIcon from '@/assets/navbar/customer.svg?inline';
import ProfileIcon from '@/assets/navbar/profile.svg?inline';
import LogoutIcon from '@/assets/navbar/logout.svg?inline';
import AdminIcon from '@/assets/navbar/admin.svg?inline';
import EventFlow from '@/assets/navbar/event-flow.svg?inline';
import ThreeLine from '@/assets/navbar/three-line.svg?inline';
import { EventResponse } from '@/model/Event';

const MOBILE_BREAKPOINT = 1024;

@Component({
    components: {
        CustomerIcon,
        DashboardIcon,
        ProfileIcon,
        LogoutIcon,
        AdminIcon,
        NavItem,
        Selector,
        EventFlow,
        ThreeLine,
    },
    computed: {
        ...mapGetters({
            getEvent: 'eventStorage/getEvent',
        }),
    },
    methods: {
        ...mapActions({
            logout: 'authenticationStorage/logout',
        }),
    },
})
export default class NavBar extends Vue {
    @Prop() user!: User | null;

    isMobile = globalThis.innerWidth <= MOBILE_BREAKPOINT;

    isOpen = !this.isMobile;

    getEvent!: EventResponse | null;

    logout!: () => Promise<void>;

    mounted(): void {
        globalThis.addEventListener('resize', this.handleResize);
        globalThis.addEventListener('keydown', this.handleKeydown);
    }

    beforeDestroy(): void {
        globalThis.removeEventListener('resize', this.handleResize);
        globalThis.removeEventListener('keydown', this.handleKeydown);
    }

    handleResize(): void {
        const isMobile = globalThis.innerWidth <= MOBILE_BREAKPOINT;

        if (isMobile !== this.isMobile) {
            this.isMobile = isMobile;
            this.isOpen = !isMobile;
        }
    }

    handleKeydown(event: KeyboardEvent): void {
        if (this.isMobile && this.isOpen && event.key === 'Escape') {
            this.close();
        }
    }

    @Watch('$route')
    onRouteChanged(): void {
        if (this.isMobile) {
            this.close();
        }
    }

    toggle(): void {
        this.isOpen = !this.isOpen;
    }

    close(): void {
        this.isOpen = false;
    }

    onLogout(): void {
        this.logout().finally(() => {
            this.$router.push({ name: 'Login' });
        });
    }
}
